import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';
import * as PostTypes from '../constants/PostTypes';

const getFeedRights = (type, params = {}) => {
  switch (type) {
    case GROUP_FEED_TYPE:
    case MY_GROUPS_FEED_TYPE: {
      return {
        canNotify: {
          [PostTypes.POST]: false,
          [PostTypes.TRIP]: false,
          [PostTypes.EVENT]: false,
          [PostTypes.CHECKIN]: false,
        },
      };
    }
    case NETWORK_FEED_TYPE:
    default: {
      const {
        currentUser: { notify_rights: notifyRights },
      } = params;

      return {
        canNotify: {
          [PostTypes.POST]: notifyRights.user_can_notify_on_feed_post,
          [PostTypes.TRIP]: notifyRights.user_can_notify_on_trip_location,
          [PostTypes.EVENT]: notifyRights.user_can_notify_on_event,
          [PostTypes.CHECKIN]: notifyRights.user_can_notify_on_current_location,
        },
      };
    }
  }
};

export default getFeedRights;
